import { cardTitle, title } from 'assets/jss/material-kit-react.js'

import imagesStyle from 'assets/jss/material-kit-react/imagesStyles.js'

const testStyle = {
  section: {
    padding: '10px 0',
    textAlign: 'center',
  },
  title: {
    ...title,
    marginBottom: '2rem',
    marginTop: '30px',
    minHeight: '32px',
    textDecoration: 'none',
  },
  titleIcon: {
    marginRight: '5px',
    fontSize: '2.25rem',
  },
  iconHeader: {
    display: 'inherit',
    paddingLeft: '80px',
    paddingRight: '80px',
    '@media (max-width: 1200px)': {
      paddingLeft: '50px',
      paddingRight: '50px',
    },
    '@media (max-width: 576px)': {
      paddingLeft: '20px',
      paddingRight: '20px',
    },
  },
  itemGrid: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  cardTitle,
  ...imagesStyle,
  imgMyStyle: {
    width: '100%',
  },
  cardHeader: {
    width: 'auto',
    textAlign: 'center',
    marginLeft: '20px',
    marginRight: '20px',
    marginTop: '-40px',
    padding: '20px 0',
    marginBottom: '15px',
  },
  cardFooter: {
    paddingTop: '0rem',
    border: '0',
    borderRadius: '6px',
    justifyContent: 'center !important',
  },
}

export default testStyle
